import {setViewProductsPageInfo, resetOffset} from "./Functions/Helpers";
import React from "react";
import {WooContext} from "./WooContext";
import LoadSpinner from "./Elements/LoadSpinner";
import Button from "./Elements/Button";
import {ButtonStyles} from "./Elements/consts";

function ProductSectors(productSectors) {
    const {currentSectorState, pagedState, pageInfoState} = React.useContext(WooContext);
    const [currentSector, setCurrentSector] = currentSectorState;
    const [pageInfo, setPageInfo] = pageInfoState;
    const [,setPaged] = pagedState;
    return (
        <>
        {productSectors.loading && <LoadSpinner/>}
        {productSectors.data && <ul className="filter-options filter-options-sectors">
            {productSectors.data.productSectors.nodes.map((sectorItem, index) => (
                <li key={index} className={sectorItem.databaseId === currentSector.databaseId ? 'active' : ''}>
                    <Button style={ButtonStyles.outlineSecondary} href={sectorItem.uri} onClick={(e) => {
                        e.preventDefault();
                        setCurrentSector(sectorItem.databaseId === currentSector.databaseId ? {databaseId:0} : sectorItem);
                        if (sectorItem.databaseId === currentSector.databaseId && sectorItem.databaseId === pageInfo.databaseId) {
                            setPageInfo({databaseId:0});
                            setViewProductsPageInfo();
                        }
                        resetOffset(setPaged);
                    }}>
                        <span>
                            {sectorItem.name}
                        </span>
                    </Button>
                </li>
            ))}
        </ul>}
    </>
    );
}

export default ProductSectors;